import { Fragment } from "react";
import TransitionOnLoad from "Components/TransitionOnLoad";
import { Card, CardBody } from "reactstrap";
import PageHeading from "Layout/AppMain/PageHeading";
import ContactInformation from "../Components/ContactInformation";
import Video from "Components/Video/Video";

const ContactDetails = () => {
    return (
        <Fragment>
            <PageHeading />
            <TransitionOnLoad className="d-flex justify-content-between flex-row align-items-center">
                <Card>
                    <CardBody >
                        <div className="d-flex flex-row gap-3 p-4">

                            <div className="w-50">

                                <ContactInformation />
                            </div>
                            <div className="w-50">
                                <Video link="https://www.youtube.com/embed/Loz98I_44oQ" title="YouTube video" h="348px" />
                            </div>

                        </div>
                    </CardBody>
                </Card>
            </TransitionOnLoad>
        </Fragment>
    )
}

export default ContactDetails;
